import {  Modal, Table } from "antd";
import React, { useEffect, useState } from "react";
import { ApiService, Template } from "../api";
import { t } from "i18next";

type Props = {
  start_date: string;
  end_date: string;
  location: string;
  visible: boolean; 
  onClose: () => void;
};


const NearbyWorksModal = (props: Props) => {
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    props.end_date && loadNearbyWorks();
  }, [props.end_date, props.start_date]);
  
  const loadNearbyWorks = async () => {
    const result = await ApiService.apiSimopsNearbyRequestList(props.end_date, props.location, props.start_date);
    setData(result);
  };

  return (
    <Modal
      title={t("Near by Works")}
      open={props.visible}
      onCancel={() => props.onClose()}
      width={800}
      footer={null}
    >
      <Table dataSource={data} bordered>
        <Table.Column title={t("Number")} dataIndex="number"></Table.Column>
        <Table.Column
          title={t("Description")}
          dataIndex="description"
        ></Table.Column>
        <Table.Column
          title={t("Template")}
          dataIndex="template"
          render={(template: Template) => template.name}
        ></Table.Column>
        <Table.Column
          title={t("Status")}
          dataIndex={["status", "name"]}
        ></Table.Column>
        <Table.Column title={t("Start Date")} dataIndex="start_date"></Table.Column>
        <Table.Column title={t("End Date")} dataIndex="end_date"></Table.Column>
      </Table>
    </Modal>
  );
};

export default NearbyWorksModal;
